import { combineReducers, compose, createStore } from 'redux';

import behavior from './reducers/behaviorReducer.ts';
import preview from './reducers/fullscreenPreviewReducer.ts';
import messages from './reducers/messagesReducer.ts';
import quickButtons from './reducers/quickButtonsReducer.ts';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers =   (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const reducer = combineReducers({ behavior, messages, quickButtons, preview });

export default createStore(reducer, composeEnhancers());
